import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { FormDataView } from "./FormData";
import { BirthdayViews } from "@/components/forms/BirthdayViews";
import { CrossCheck } from "@/components/forms/CrossCheck";

const EDIT = ["super_admin", "secretary", "records_officer", "manager"];

export default function Birthdays() {
  const { user } = useAuth();
  const [tab, setTab] = useState("register");
  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList className="bg-slate-100 mb-5 grid grid-cols-4 w-full sm:w-auto sm:inline-flex h-11 sticky top-16 z-20">
        <TabsTrigger value="register" className="h-9" data-testid="bday-tab-register">Register</TabsTrigger>
        <TabsTrigger value="month" className="h-9" data-testid="bday-tab-month">This month</TabsTrigger>
        <TabsTrigger value="year" className="h-9" data-testid="bday-tab-year">By month</TabsTrigger>
        <TabsTrigger value="check" className="h-9" data-testid="bday-tab-check">Cross-check</TabsTrigger>
      </TabsList>
      <TabsContent value="register"><FormDataView templateId="tpl_birthdays" eyebrow="Forms & Data" /></TabsContent>
      <TabsContent value="month"><BirthdayViews mode="month" canEdit={EDIT.includes(user.role)} refreshKey={tab} /></TabsContent>
      <TabsContent value="year"><BirthdayViews mode="year" canEdit={EDIT.includes(user.role)} refreshKey={tab} /></TabsContent>
      <TabsContent value="check"><CrossCheck refreshKey={tab} /></TabsContent>
    </Tabs>
  );
}
